import { z } from 'zod'
import { instantSchema } from '../validators/temporal.validator.js'

/**
 * An image a venue has uploaded for its marketing pages.
 *
 * `url` is absolute and public — no signature, no expiry. Every other image in
 * this app is private and served through a signed URL that goes stale; these
 * are on a venue's public pricing page, fetched a dozen at a time by every
 * visitor, and have to be cacheable at the edge.
 */
export const marketingImageDtoSchema = z.object({
  url: z.string(),
  uploadedAt: instantSchema,
})

export type MarketingImageDto = z.infer<typeof marketingImageDtoSchema>

export const marketingImageListDtoSchema = z.array(marketingImageDtoSchema)
